import { IKeyValue } from "../components/Administrations/types";

/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
type ILANDevice = { [key: string]: string };
type IZONEDevice = { [key: string]: string };
type IIPInterface = { [key: string]: string };
type IRfFeed = { [key: string]: string };
type IConnectRfFeed = { [key: string]: string };
type ISummaryDevice = { [key: string]: string };
type ITrapReceive = { [key: string]: string };
type ILteX2ConnectionPeer = { [key: string]: string };
type INgX2ConnectionPeer = { [key: string]: string };
type IRadioNode = { [key: string]: string };
type INrCell = { [key: string]: string };
type ILteCell = { [key: string]: string };
type INrCellNode = { [key: string]: string };

export const xsdPathStr = {
  lanDevice: {
    tableId: "LANDevice", // tableId must be in lowercase.
    lanDevice: "LANDevice",
    internetGatewayDevice: "InternetGatewayDevice",
    lanEthernetInterfaceConfig: "LANEthernetInterfaceConfig",
    duplex: "DuplexMode",
    enable: "Enable",
    maxBitRate: "MaxBitRate",
    name: "Name",
  } as ILANDevice,
  ipInterface: {
    tableId: "IPInterface",
    ipinterface: "IPInterface",
    lanHostConfigManagement: "LANHostConfigManagement.IPInterface",
    ipInterfaceSubnetMask: "IPInterfaceSubnetMask",
    ipInterfaceIpAddress: "IPInterfaceIPAddress",
    description: "Description",
    vlanId: "VLANID",
    forwardingGroupIndex: "ForwardingGroupIndex",
    dhcpServerEnable: "DHCPServerEnable",
    egressQosGroup: "EgressQoSProfile",
    enable: "Enable",
  } as IIPInterface,
  deletepath: "deletepath",
  generalAuthentication: {
    authenticationSetup: "authentication.setup",
    authenticationExternal: "authentication.external",
  },
  radius: {
    serverAddress: "radius.hostname",
    port: "radius.port",
    profileAttributeType: "radius.profile.attribute.type",
    sharedSecret: "radius.shared.secret",
  },
  tacacs: {
    serverAddress: "tacacs.hostname",
    port: "tacacs.port",
    sharedSecret: "tacacs.secret",
    profileAttributeName: "tacacs.profile.attribute.name",
  },
  saml: {
    authorizedServersList: "saml.authorized.servers.list",
    caEnable: "saml.ca.enable",
    profileAttributeName: "saml.profile.attribute.name",
    usernameAttributeName: "saml.username.attribute.name",
    samlVersion: "saml.version",
  },
  rfFeed: {
    tableId: "RfFeed", // tableId must be in lowercase.
    rfFeed: "RFFeed",
    internetGatewayDevice: "InternetGatewayDevice",
    type: "Type",
    dlarfcn: "DLARFCN",
    ularfcn: "ULARFCN",
    dlBandwidth: "DLBandwidth",
    ulBandwidth: "ULBandwidth",
    //dlAttenuation: "DLAttenuation",
  } as IRfFeed,
  connectRfFeed: {
    tableId: "connectRfFeed", // tableId must be in lowercase.
    lanDevice: "LANDevice",
    internetGatewayDevice: "InternetGatewayDevice",
    radioUnit: "RadioUnit",
    radioInputModule: "RadioInputModule",
    enable: "Enable",
    rfFeedIndex: "RFFeedIndex",
  } as IConnectRfFeed,
  zoneDevice: {
    tableId: "ZONEDevice", // tableId must be in lowercase.
    lanDevice: "LANDevice",
    lte: "LTE",
    zone: "Zone",
    internetGatewayDevice: "InternetGatewayDevice",
    config: "Config",
    ranId: "RAN",
    rfId: "RF",
    fapService: "FAPService",
    cellRestriction: "CellRestriction",
    barringEmergency: "BarringForEmergency",
    eARFCNDL: "EARFCNDL",
    eARFCNUL: "EARFCNUL",
    ARFCNDL: "ARFCNDL",
    ARFCNUL: "ARFCNUL",
    ulBandwidth: "ULBandwidth",
    dlBandwidth: "DLBandwidth",
    downlinkBandwidthMhz: "DownlinkBandwidthMhz",
    uplinkBandwidthMhz: "UplinkBandwidthMhz",
    type: "Type",
    priority: "Priority",
    ng: "NG",
    cellList: "CellList",
    description: "Description",
  } as IZONEDevice,
  summaryDevice: {
    lte: "LTE",
    internetGatewayDevice: "InternetGatewayDevice",
    config: "Config",
    selfConfig: "SelfConfig",
    pciLockEnabled: "PhyCellIDLockEnable",
    fapService: "FAPService",
    fapControl: "FAPControl",
    system: "System",
    location: "Location",
    operatingMode: "OperatingMode",
    contact: "Contact",
    summary: "Summary",
    servicesNode: "ServicesNode",
    hostname: "HostName",
    hostPort: "1025",
    latitude: "Latitude",
    longitude: "Longitude",
    ng: "NG",
    ngPeerBasePath: "InternetGatewayDevice.FAPService.1.FAPControl.NG.X2Connection",
    ltePeerBasePath: "InternetGatewayDevice.FAPService.1.FAPControl.LTE.X2Connection",
    rcpMode: "InternetGatewayDevice.ServicesNode.1025.RCP.Mode",
    duMode: "InternetGatewayDevice.System.ORANSharingConfig.1.Mode",
    description: "Description",
    clusterId: "InternetGatewayDevice.DeviceInfo.ClusterID",
  } as ISummaryDevice,
  trapReceive: {
    trap: "trap",
    config: "config",
    auth: "auth",
    community: "trap.config.community",
    engineId: "trap.config.engineId",
    port: "trap.config.port",
    userName: "trap.config.username",
    version: "trap.config.version",
    password: "password",
    privacy: "privacy",
    authPassword: "trap.config.auth.password",
    privPassword: "trap.config.privacy.password",
    authProtocol: "trap.config.auth.protocol",
    privProtocol: "trap.config.privacy.protocol",
    recievePort: "trap.receive.port",
    trapAuthPassword: "snmp.trap.sn.auth.pwd",
    trapPrivPassword: "snmp.trap.sn.priv.pwd",
  } as ITrapReceive,
  lteX2ConnectionPeer: {
    tableId: "LteX2Connection",
    ltePeerBasePath: "InternetGatewayDevice.FAPService.1.FAPControl.LTE.X2Connection.Peer",
    index: "",
    enable: "Enable",
    name: "Name",
    address: "Address",
    //connectionState :"ConnectionState",
    //localAddress : "LocalAddress",
    plmnId: "PLMNID",
    port: "Port",
    tac: "TAC",
    type: "Type",
    eNodeBID: "eNodeBID",
    gNodeBID: "gNodeBID",
    //remoteAddress : "RemoteAddress",
    //connectionId : "ConnectionId",
    isENDCX2: "IsENDCX2",
  } as ILteX2ConnectionPeer,
  ngX2ConnectionPeer: {
    tableId: "NgX2Connection",
    ltePeerBasePath: "InternetGatewayDevice.FAPService.1.FAPControl.NG.X2Connection.Peer",
    index: "",
    enable: "Enable",
    name: "Name",
    address: "Address",
    //connectionState :"ConnectionState",
    //localAddress : "LocalAddress",
    plmnId: "PLMNID",
    port: "Port",
    eNodeBID: "eNodeBID",
    //remoteAddress : "RemoteAddress",
    //connectionId : "ConnectionId"
  } as INgX2ConnectionPeer,
  radioNode: {
    tableId: "RadioNode",
    radioNodeBasePath: "InternetGatewayDevice.RadioNode",
    index: "",
    enable: "Enable",
    cellName: "Name",
    radio: "Radio",
    band: "Band",
    bypassAlarms: "BypassAlarms",
    lteCellBasePath: "InternetGatewayDevice.LTECell",
    radioNode: "RadioNode",
    cellDescription: "Description",
    cellConfig: "CellConfig",
    lte: "LTE",
    ran: "RAN",
    rf: "RF",
    common: "Common",
    cellId: "CellID",
    mode: "Mode",
    ReferenceSignalPowerConfigured: "ReferenceSignalPowerConfigured",
    power: "ReferenceSignalPowerConfigured",
    cellPci: "PhyCellIDConfigured",
    actualOta: "ActualOTAReferenceSignalPower",
    pci: "PhyCellIDConfigured",
    ethernetId: "EthernetID",
    nr: "NR",
    nrCellBasePath: "InternetGatewayDevice.NRCell",
    radioConfiguration: "RadioConfiguration",
    radioIndex: "RadioIndex",
    radioUnit: "RadioUnit",
    radioUnitIndex: "RadioUnitIndex",
    radioNodeIndex: "RadioNodeIndex",
    sectorDevice: "SectorDevice",
    operatingMode: "CellConfig.NG.RAN.RF.OperatingMode",
    sleepCellAlarm: "CellConfig.NG.RAN.RF.SleepingCellAlarm.Enable",
    cellTableId: "LTECell",
    nodeType: "NodeType",
    lteCellConfig: "CellConfig.LTE.RAN.RF",
    nrCellConfig: "CellConfig.NG.RAN.RF",
    radioUnitBasePath: "InternetGatewayDevice.RadioUnit",
    name: "Name",
  } as IRadioNode,
  nrCellNode: {
    tableId: "NrCell",
    radioNodeBasePath: "InternetGatewayDevice.RadioNode",
    index: "",
    enable: "Enable",
    cellName: "Name",
    radio: "Radio",
    band: "Band",
    bypassAlarms: "BypassAlarms",
    lteCellBasePath: "InternetGatewayDevice.LTECell",
    radioNode: "RadioNode",
    cellDescription: "Description",
    cellConfig: "CellConfig",
    lte: "LTE",
    ran: "RAN",
    rf: "RF",
    common: "Common",
    cellId: "CellID",
    mode: "Mode",
    ReferenceSignalPowerConfigured: "ReferenceSignalPowerConfigured",
    power: "CellConfig.NG.RAN.RF.PBCHPowerConfigured",
    cellPci: "CellConfig.NG.RAN.RF.PhyCellIDConfigured",
    actualOta: "CellConfig.NR.RAN.RF.ActualOTAReferenceSignalPower",
    txPower: "CellConfig.NG.RAN.RF.TxPowerPercentage",
    pbchPower: "CellConfig.NG.RAN.RF.PBCHPowerConfigured",
    pci: "PhyCellIDConfigured",
    ethernetId: "EthernetID",
    nr: "NR",
    ng: "NG",
    nrCellBasePath: "InternetGatewayDevice.NRCell",
    radioConfiguration: "RadioConfiguration",
    radioIndex: "RadioIndex",
    radioUnit: "RadioUnit",
    radioUnitIndex: "RadioUnitIndex",
    radioNodeIndex: "RadioNodeIndex",
    sectorDevice: "SectorDevice",
    operatingMode: "CellConfig.NG.RAN.RF.OperatingMode",
    sleepCellAlarm: "CellConfig.NG.RAN.RF.SleepingCellAlarm.Enable",
    radioUnitBasePath: "InternetGatewayDevice.RadioUnit",
  } as INrCellNode,
  nrCell: {
    tableId: "NrCell",
    nrCellBasePath: "InternetGatewayDevice.NRCell",
    index: "",
    enable: "Enable",
    name: "Name",
  } as INrCell,
  lteCell: {
    tableId: "LteCell",
    lteCellBasePath: "InternetGatewayDevice.LTECell",
    index: "",
    enable: "Enable",
    name: "Name",
  } as ILteCell,
  systemProperties: {
    name: "snmp.agent.system.name",
    location: "snmp.agent.system.location",
    contact: "snmp.agent.system.contact",
    description: "snmp.agent.system.description",
    maintenanceModeSystem: "maintenanceMode.System",
    fileUploadTarget: "system.filesystem.createuploadtargets.enabled",
    userDefinedDirectory: "monitor.userdefined.enabled",
    maintenanceModeStandBy: "maintenanceMode.StandBy",
  } as IKeyValue,
  dataPollingProperties: {
    privatekey: "data-poller-privatekey",
    port: "data-poller-port",
    dbgEnable: "data-poller-dbg-enable",
    kpiEnable: "data-poller-kpi-enable",
    alarmEnable: "data-poller-alarm-enable",
    enable: "data-poller-enable",
    cmEnable: "data-poller-cm-enable",
    ebEnable: "data-poller-eb-enable",
    maxDays: "data-poller-max-days",
    pubkey: "data-poller-pubkey",
    host: "data-poller-host"
  } as IKeyValue,
  accessControlSettings:{
    minimumAgeDays: "user.password.minimumagedays",
    expiryWarningDays: "user.password.expirywarningdays",
    minimumLength: "user.password.minimumlength",
    reusePreventionCount: "user.password.reusepreventioncount",
    reusePreventionDays: "user.password.reusepreventiondays",
    messageOfDay: "user.messageofday",
    accountLockoutEnabled: "user.account.lockout.enabled",
    accountLockoutFailedCount: "user.account.lockout.failedcount",
    inactivityLogoutDurationMinutes: "user.inactivity.logoutdurationminutes",
    bannerEnabled: "user.banner.enabled",
    bannerTitle: "user.banner.title"
  } as IKeyValue
};

export const OPERATIONTYPES = {
  CREATE: "CREATE",
  UPDATE: "UPDATE",
  DELETE: "DELETE",
  GETGENERALAUTH: "GET_GENERAL_AUTH_PARAMETERS",
  SETGENERALAUTH: "SET_GENERAL_AUTH_PARAMETERS",
  GETRADIUS: "GET_RADIUS_PARAMETERS",
  SETRADIUS: "SET_RADIUS_PARAMETERS",
  GETLDAP: "GET_LDAP_PARAMETERS",
  SETLDAP: "SET_LDAP_PARAMETERS",
  GETSAML: "GET_SAML_PARAMETERS",
  SETSAML: "SET_SAML_PARAMETERS",
  GETTACACS: "GET_TACACS_PARAMETERS",
  SETTACACS: "SET_TACACS_PARAMETERS",
};

export const MAXBITRATELIST = ["10", "100", "1000", "10000", "100F", "2500"];

export const HALFMAXBITRATELIST = ["100", "100F", "1000"];

export const constStr = {
  yesDelete: "Yes, Delete",
  yesSave: "Yes, Save",
  taskBackupLocation: "/data/kpi/sn_cm_backups",
  ok: "Okay",
  ungroupedSiteId: "99999999",
  ungrouped: "ungrouped",
  initialRegionObjectKey: "00000000-0000-0000-0000-000000000000",
  enable: "Enable",
  disable: "Disable",

  stopCheckLocation: "LTE_RN_LOCATION_STOP_CHECK_LOCATION",
  checkLocation: "LTE_RN_LOCATION_CHECK_LOCATION",
  createBaseline: "LTE_RN_LOCATION_CREATE_BASELINE",
  neighborList: "LTE_SELFCONFIG_NEIGHBOR_LIST",
  txPower: "LTE_SELFCONFIG_TX_POWER",
  migrateStatus: {
    Pending: "Initial request to migrate a device.",
    Initiated: "Config template has been sent to legacy SNET to update the ManagementServerURL.",
    Complete: "Device has connected successfully to the new AMS.",
    Error: "Migration failed.",
  } as IKeyValue,
};

export const invalidStr = {
  ipAddress: {
    required: "IP Address is required!.",
    invalid: "Invalid IpAddress.It must be in IPv4 or IPv6 format.",
  },
  subnet: {
    required: "Subnet mask is required!.",
    invalid: "Invalid subnet mask!.",
  },
  port: {
    invalid: "Port value exceeds limits: Please enter a value between 1 to 65535.",
    type: "Profile attribute type value exceeds limits: Please enter a value between 1 to 255.",
  },
};

export const statusStr = ["COMMITTED", "SENT", "RECEIVED", "INIT"];

export const customTasks = {
  auditReports: "Audit Reports",
  customAuditReport: "Custom Audit Report",
  bulkConfiguration: "Apply Configuration Template",
  exportSnDataModel: "Export Node Data Model",
  interfaceStatisticsReset: "Interface Statistics Reset",
  softwareDownload: "File Download",
  lteCell: "LTE Cell Enable/Disable",
  lteCoreReset: "LTE Core Reset",
  lteRemStart: "LTE REM Start",
  lteRemStop: "LTE REM Stop",
  lteRnLocation: "LTE RN Location",
  lteSelfConfig: "LTE Self Configuration",
  lteX2SessionReset: "LTE X2 Reset",
  ngCoreReset: "NG Core Reset",
  snDbBackup: "Node Database Backup",
  snDbRestore: "Node Database Restore",
  fileManagementCreate: "Node File Management",
  logBundle: "Node Log Bundle",
  setPassword: "Node Password Change",
  // nrX2SessionReset: "NR X2 UESession Reset",
  nrCell: "NR Cell Enable/Disable",
  radioNodeOperations: "Radio Node LED Operations",
  reboot: "Reboot",
  radioNodeReplace: "Replace Radio Node",
  radiounitTroubleshooting: "RU Log Bundle",
  setDebug: "Set Debug Level",
  lciSetPassword: "Set LCI Password",
  //softwareDownloadUpdate: "Software Download and Update",
  softwareRevert: "Software Revert",
  softwareUpdate: "Software Update",
  testSnmpTrap: "Test SNMP Trap",
  //pmReports: "Daily KPI Reports",

  // deleteCBRSCertificate: "Delete CBRS Certificate",
  // certificateDelete: "Delete Certificate",
  // sshKeysDelete: "Delete SSH Keys",
  // diagnostics: "Diagnostics",
  // eventSummaryReport: "Event Summary Report",

  // statistics: "Statistics",
  // softwareDownload: "Software Download",
  // certificateImport: "Certificate Import",
  // generateDownloadCSRCertificate: "Generate Download CSR Certificate",
  // uploadAddCBRSCertificate: "Upload Add CBRS Certificate",
  // uploadReplaceCBRSCertificate: "Upload Replace CBRS Certificate",

  // statsReset: "Stats Reset",
  // databaseBackup: "Database Backup",
  // setDebug: "Set Debug",

  // databaseIntegrity: "Database Integrity",
  // logMark: "Log Mark",
  // logRotate: "Log Rotate",
  // sshKeysGenerate: "SSH Keys Generate",
  // umtsCellDisable: "Umts Cell Disable",
  // umtsCellEnable: "Umts Cell Enable",
  // umtsCoreReset: "Umts Core Reset",
  // umtsRemStart: "Umts Rem Start",
  // umtsRemStop: "Umts Rem Stop",
  // umtsSelfConfig: "Umts Self Config",
  // umtsUeStatsClear: "Umts UE Stats Clear",
  // lteCellDisable: "LTE Cell Disable",
  // lteCellEnable: "LTE Cell Enable",
  // lteRemStart: "LTE Rem Start",
  // lteRemStop: "LTE Rem Stop",
  // lteClearAlarm: "LTE Clear Alarm",
  // lteRnLocation: "LTE RN Location",
  // channelScan: "Channel Scan",
  // systemAudit: "System Audit",
  // nrSelfConfig: "NR Self Config",
  // nrSystemCertificateDevicecertGeneratecsr: "NR System Certificate Devicecert Generate csr",
  // nrUploadAddDeviceCertificate: "NR Upload Add Device Certificate",
  // nrCellEnable: "NR Cell Enable",
  // nrCellDisable: "NR Cell Disable",
} as IKeyValue;

export const auditReportTypeValues = {
  none: "None",
  customAuditReport: "CUSTOM_AUDIT_REPORT",
  customAuditReportLabel: "Custom Audit Report",
} as const;

export const taskKeyProps = {
  auditReports: {
    auditReportType: "AUDIT_REPORT_TYPE",
    emailGroupName: "EMAIL_GROUP_NAME",
    templateName: "TEMPLATE_NAME",
    manualAttributes: "MANUAL_ATTRIBUTES",
    creator: "CREATOR",
  } as IKeyValue,
  customAuditReport: {
    auditReportType: "AUDIT_REPORT_TYPE",
    emailGroupName: "EMAIL_GROUP_NAME",
    templateName: "TEMPLATE_NAME",
    manualAttributes: "MANUAL_ATTRIBUTES",
    nodeType: "NODE_TYPE",
    reportFileName: "REPORT_FILE_NAME",
    creator: "CREATOR",
  } as IKeyValue,
  commanForAll: {
    name: "name",
    description: "description",
    domainKey: "domainKey",
    scheduleOnce: "scheduleOnce",
    nextTime: "nextTime",
    period: "period",
    className: "className",
  } as IKeyValue,
  taskProperties: {
    parentTask: "parentTask",
    setParameter: "PARAMETER_SET",
    encryptPasswords: "encryptPasswords",
    tasksMaxConcurrentDevices: "tasksMaxConcurrentDevices",
  } as IKeyValue,
  reboot: {
    radioUnitId: "RADIOUNIT_ID",
    radioNodeId: "NODE",
    sectorDeviceId: "SECTORDEVICE_ID",
    cleanOption: "VALUE", //CleanOption dropdown,
  } as IKeyValue,
  bulkConfiguration: {
    templateName: "CONFIGURATION_TEMPLATE_KEY",
  } as IKeyValue,
  softwareDownloadUpdate: {
    protocol: "PROTOCOL",
    softwareUpdateClean: "VALUE",
    sshKeyIndex: "SSH_KEY_INDEX",
    serverType: "FILE_TRANSFER_TYPE",
    sshOperation: "SSH_OPERATION",
    port: "PORT",
    username: "USERNAME",
    password: "PASSWORD",
    hostName: "HOSTNAME",
    fileName: "REMOTE_FILENAME",
    localFileName: "LOCAL_FILENAME",
  } as IKeyValue,
  softwareDownload: {
    protocol: "PROTOCOL",
    softwareUpdateClean: "VALUE",
    sshKeyIndex: "SSH_KEY_INDEX",
    serverType: "FILE_TRANSFER_TYPE",
    sshOperation: "SSH_OPERATION",
    port: "PORT",
    username: "USERNAME",
    password: "PASSWORD",
    hostName: "HOSTNAME",
    fileName: "REMOTE_FILENAME",
    localFileName: "LOCAL_FILENAME",
  } as IKeyValue,
  radioNodeReplace: {
    oldRadioNodeId: "NODEID",
    newRadioNodeId: "WITHNODEID",
  } as IKeyValue,

  lteCell: {
    zoneIdSet: "ZONEID_SET",
    zoneIdValue: "ZONE_VALUE",
    allCell: "ALL",
    cellIdSet: "CELLID_SET",
    cellIdValue: "CELLID",
  } as IKeyValue,
  nrCell: {
    zoneIdSet: "ZONEID_SET",
    zoneIdValue: "ZONE_VALUE",
    allCell: "ALL",
    cellIdSet: "CELLID_SET",
    cellIdValue: "CELLID",
  } as IKeyValue,
  snDbBackup: {
    dbCloneSupported: "DBCLONE_SUPPORTED",
    includeDbLogging: "INCLUDE_LOGGING_DB",
    generateFileName: "GENERATE_FILENAME",
    prefixFileName: "PREFIXFILENAME_VALUE",
    fileName: "FILENAME_VALUE",
  } as IKeyValue,
  snDbRestore: {
    fileName: "FILENAME",
  } as IKeyValue,
  softwareUpdate: {
    updatePackage: "PACKAGE",
    cleanOption: "VALUE",
  } as IKeyValue,
  radioNodeOperations: {
    idType: "TYPE",
    actionName: "ACTION",
    radioNodeId: "NODEID",
    followIMSI: "IMSI",
  } as IKeyValue,
  exportSnDataModel: {
    outputFormat: "export.type",
    outputDirectory: "export.dir",
  } as IKeyValue,
  setDebug: {
    setDebug: "SET_DEBUG",
  } as IKeyValue,
  lciSetPassword: {
    password: "lciPassword",
  } as IKeyValue,
  setPassword: {
    username: "USER_NAME",
    password: "CURRENT_PASSWORD",
    newPassword: "NEW_PASSWORD",
  } as IKeyValue,
  radiounitTroubleshooting: {
    radiounitLogRequest: "BUTTONSELECTED",
    radiounitId: "RADIOUNIT_ID",
  } as IKeyValue,
  lteRnLocation: {
    lteRnLocationRequest: "BUTTONSELECTED",
    radioNodeId: "rnId",
    zoneIdValue: "ZONE_VALUE",
    isAll: "ALL",
  } as IKeyValue,
  lteSelfConfig: {
    lteSelfConfigType: "BUTTONSELECTED",
    zoneIdValue: "ZONE_VALUE",
    allString: "BUTTON3SELECTED",
    txPowerType: "TYPE",
    neighborToCover: "LTE_NUM_NBRS_TO_COVER_VALUE",
    maxSwing: "LTE_MAX_SWING_VALUE",
    targetRSRP: "LTE_TARGET_RSRP_VALUE",
    targetSIR: "LTE_TARGET_SIR_VALUE",
    nominalPLHigh: "LTE_NOMINAL_PL_HIGH_VALUE",
    nominalPLLow: "LTE_NOMINAL_PL_LOW_VALUE",
    zoneRemValue: "ZONE_REM_VALUE",
  },
  fileManagementCreate: {
    nodeFileMgmtAllInString: "FILE_MANAGEMENT_CREATE",
    password: "PASSWORD",
  },
  testSnmpTrap: {
    trapName: "SnmpTrapName",
    trapTarget: "SnmpTrapTarget",
    trapSeverity: "SnmpTrapSeverity",
  } as IKeyValue,
  lteRemStart: {
    zoneIdValue: "ZONE_VALUE",
    referenceSinglePowerEnabled: "USER_REF_SIG_PWR_CFG",
  } as IKeyValue,
  taskExecutionType: {
    executionTarget: "EXECUTION_TARGET",
    executionTargetName: "EXECUTION_TARGET_NAME",
  } as IKeyValue,
} as { [key: string]: IKeyValue };

export const repeatOptions = [
  {
    text: "Does not repeat",
    value: "0",
  },
  {
    text: "Hourly",
    value: "3600000",
  },
  {
    text: "Daily(Same hour)",
    value: "86400000",
  },
  {
    text: "Weekly(Same day & hour)",
    value: "604800000",
  },
];

export const AuthenticationOptions = [
  {
    name: "NONE",
    value: "NO_AUTH",
  },
  {
    name: "MD5",
    value: "MD5_AUTH",
  },
  {
    name: "SHA",
    value: "SHA_AUTH",
  },
];

export const PrivacyOptions = [
  {
    name: "NONE",
    value: "NO_PRIV",
  },
  {
    name: "DES",
    value: "DES_PRIV",
  },
  {
    name: "AES_128",
    value: "AES_128_PRIV",
  },
];

export const samlVersionList = [
  {
    name: "SAML 1.1",
    value: "1.1",
  },
];

export const snmpGroupData = [
  {
    id: 0,
    key: "8080",
    parentKey: "NONE",
    name: "8080",
    port: 162,
    ipAddresses: ["10.132.66.111"],
    enabled: true,
    community: "public",
    version: 1,
    contextName: "",
    userName: "",
    authPassword: "",
    privPassword: "",
    authProtocol: "NO_AUTH",
    privProtocol: "NO_PRIV",
    enableHeartbeat: true,
    heartbeatInterval: 5,
    lastHeartbeatTrap: "",
    dbConnType: "ROOT",
  },
  {
    id: 1,
    key: "group-two",
    parentKey: "NONE",
    name: "group-two",
    port: 168,
    ipAddresses: ["10.132.66.111"],
    enabled: true,
    community: "public",
    version: 1,
    contextName: "",
    userName: "",
    authPassword: "",
    privPassword: "",
    authProtocol: "NO_AUTH",
    privProtocol: "NO_PRIV",
    enableHeartbeat: false,
    heartbeatInterval: 5,
    lastHeartbeatTrap: null,
    dbConnType: "ROOT",
  },
];

export const rnLedActions = ["Locate Radio Node", "Follow IMSI", "Set LED Normal"];

export const exportDMFormat = [
  {
    text: "Flat XML",
    value: "FLAT_XML",
  },
  {
    text: "Structured XML",
    value: "STRUCTURED_XML",
  },
  {
    text: "CLI",
    value: "CLI",
  },
  {
    text: "XSD Structured XML",
    value: "STRUCTURED_W3C_XML",
  },
  {
    text: "LCI Profile",
    value: "LCI_PROFILE",
  },
];

export const ZoneTypeList = [
  {
    name: "SONConfigAndScanZone",
    value: "SONConfigAndScanZone",
  },
  {
    name: "SONScanZone",
    value: "SONScanZone",
  },
  {
    name: "UnknownZone",
    value: "UnknownZone",
  },
];

export const eventNameExcluded = [
  "eranNotifExternalAlarm",
  "eranNotifOpticalPortSwitch",
  "eranNotifPowerFault",
  "eranNotifRadioModuleServiceOff",
  "eranNotifOutputUnderPowerThreshold",
  "eranNotifInputOverPowerThreshold",
  "eranNotifAlcOverRange",
  "eranNotifDeviceNotDetected",
  "eranNotifInputUnderPowerThreshold",
  "eranNotifOutputOverPowerThreshold",
  "eranNotifCoolingFanFailure",
];

export const defaultTasks = ["Database Backup", "NodeDmBackupTask", "Database Integrity", "NodeDbBackupTask"];

export const fileMgmtModuleList = [
  // { text: "CBRS Generate CSR File", value: "CBRSGenCSRFile" },
  { text: "Database Backup", value: "DatabaseBackup" },
  { text: "Debug Log", value: "DebugLog" },
  // { text: "Device Certificat Generate CSR File", value: "DeviceCertGenCSRFile" },
  { text: "Error Bundle", value: "ErrorBundle" },
  // { text: "LTE Call Performance Event Report", value: "LTECallPerformanceEventReport" },
  // { text: "LTE Pubilc Warning System Event Report", value: "LTEPubilcWarningSystemEventReport" },
  { text: "Module Unspecified", value: "ModuleUnspecified" },
  // { text: "NG Call Performance Event Report", value: "NGCallPerformanceEventReport" },
  { text: "Performance Management", value: "PerfMgmt" },
  { text: "RN Link Result", value: "RNLinkResult" },
];

export const mmwModelKeys = ["SCRN-510-28G1", "SCRN-520-28", "SCRN-530-39"];

export const migrationStatusList = ["Pending", "Initiated", "Complete", "Error"];

export const bandwidthRange = [15, 25, 50, 75, 100, 4294967295];

export const testSNMPTraps = [
  "EranNotifTest",
  "EranNotifStdWarmStart",
  "EranNotifStdColdStart",
  "EranNotifStdLinkDown",
  "EranNotifStdLinkUp",
  "EranNotifStdAuthFailure",
  "EranNotifOverTemperature",
  "EranNotifMissingEquipment",
  "EranNotifProvFault",
  "EranNotifRanapCsConnectionTerm",
  "EranNotifRanapPsConnectionTerm",
  "EranNotifIpsecDown",
  "EranNotifSoftwareMismatch",
  "EranNotifLossOfSync",
  "EranNotifCalibrationInvalid",
  "EranNotifConfigMismatch",
  "EranNotifRfMgmtFaulted",
  "EranNotifLinkDown",
  "EranNotifCellMaxPowerDeltaExceeded",
  "EranNotifNeighborhoodReferenceDelta",
  "EranNotifDhcpAllocationFailure",
  "EranNotifSystemNearingMaxSessionRate",
  "EranNotifSystemMaxSessionRateExceeded",
  "EranNotifDbInvalid",
  "EranNotifCoreIpsecTerm",
  "EranNotifPowerSupplyMissing",
  "EranNotifPowerSupplyFailed",
  "EranNotifCoolingFanFailure",
  "EranNotifMultipleCoolingFanFailures",
  "EranNotifUarfcndlChanged",
  "EranNotifRfMgmtRemRequired",
  "EranNotifRfMgmtNlcRequired",
  "EranNotifLteS1APConnectionTerm",
  "EranNotifRfMgmtSuboptimalAssignmentOfPcisDetected",
  "EranNotifFeConnectionFailure",
  "EranNotifLinkParamDegradation",
  "EranNotifDeviceCertExpiration",
  "EranNotifRfMgmtNeighborsWithConfusingPcisDetected",
  "EranNotifRfMgmtNeighborsWithCollidingPcisDetected",
  "EranNotifLteCellLossOfOtaSync",
  "EranNotifProcessGroupStopped",
  "EranNotifRnRelocated",
  "EranNotifRnLocationCheckRequired",
  "EranNotifRfMgmtPciConflictDetected",
  "EranNotifNodeRelocated",
  "EranNotifDiskThresholdExceeded",
  "EranNotifMemThresholdCross",
  "EranNotifDruCpriMapRejected",
  "EranNotifFpgaMismatch",
  "EranNotifCpriSfpNotOnApprovalListDetected",
  "EranNotifGnssFault",
  "EranNotifDruOverTemperature",
  "EranNotifDruSoftwareVersionInconsistent",
  "EranNotifDruHardwareFailure",
  "EranNotifDruFiberLength",
  "EranNotifDruMaxNumberRfChannels",
  "EranNotifDruNoClusterConfiguration",
  "EranNotifDruUlHigh",
  "EranNotifDruOpticalLinkStatus",
  "EranNotifDruMappingNotMatch",
  "EranNotifLprDisconnected",
  "EranNotifLprSoftwareVersionInconsistent",
  "EranNotifLprOverTemperature",
  "EranNotifLprHardwareFailure",
  "EranNotifLprServiceOffPcs",
  "EranNotifLprServiceOffAws",
  "EranNotifLprServiceOffPcsm",
  "EranNotifLprServiceOffAwsm",
  "EranNotifLprServiceOffWcs",
  "EranNotifLprServiceOffWcsm",
  "EranNotifLprDlLowPcs",
  "EranNotifLprDlLowPcsm",
  "EranNotifLprDlLowAwsm",
  "EranNotifLprDlLowAws",
  "EranNotifLprDlLowWcs",
  "EranNotifLprDlLowWcsm",
  "EranNotifLprOpticalLink",
  "EranNotifLprConfigurationMismatch",
  "EranNotifLteX2apConnectionTerm",
  "EranNotifNgX2apConnectionTerm",
  "EranNotifTransmissionQualityDeteriorated",
  "EranNotifTxOutOfOrder",
  "EranNotifPowerAmplifierFault",
  "EranNotifLogicalConnectionFault",
  "EranNotifInterfaceFault",
  "EranNotifTransceiverFault",
  "EranNotifAlcOverRange",
  "EranNotifOutputUnderPowerThreshold",
  "EranNotifInputUnderPowerThreshold",
  "EranNotifInputOverPowerThreshold",
  "EranNotifDeviceNotDetected",
  "EranNotifOpticalPortSwitch",
  "EranNotifOutputOverPowerThreshold",
  "EranNotifExternalAlarm",
  "EranNotifPowerFault",
  "EranNotifRadioModuleServiceOff",
  "EranNotifNgX2PeerConnectionTerm",
  "EranNotifLteX2PeerConnectionTerm",
  "EranNotifNgEndcSleepingCellStateAlarm",
  "EranNotifAll",
  "EranNotifStdAll",
];

export interface IconData {
  left_value: number | string;
  right_value: number;
  condition: string;
}

export interface CellIconState {
  dark_success: IconData;
  dark_alert: IconData;
  dark_error: IconData;
}

export interface StateData {
  [key: string]: CellIconState;
}

export const CellKpiIconState: StateData = {
  erab_establishment_sr: {
    dark_success: {
      left_value: "",
      right_value: 99,
      condition: ">=",
    },
    dark_alert: {
      left_value: 99,
      right_value: 98,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 98,
      condition: "<=",
    },
  },
  volte_establishment_sr: {
    dark_success: {
      left_value: "",
      right_value: 99,
      condition: ">=",
    },
    dark_alert: {
      left_value: 99,
      right_value: 98,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 98,
      condition: "<=",
    },
  },
  rrc_connection_establishment_sr: {
    dark_success: {
      left_value: "",
      right_value: 99,
      condition: ">=",
    },
    dark_alert: {
      left_value: 99,
      right_value: 98,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 98,
      condition: "<=",
    },
  },
  erab_drop_rate: {
    dark_success: {
      left_value: "",
      right_value: 0.5,
      condition: "<=",
    },
    dark_alert: {
      left_value: 0.5,
      right_value: 1,
      condition: "<X<",
    },
    dark_error: {
      left_value: "",
      right_value: 1,
      condition: ">=",
    },
  },
  volte_drop_rate: {
    dark_success: {
      left_value: "",
      right_value: 1,
      condition: "<=",
    },
    dark_alert: {
      left_value: 1,
      right_value: 2,
      condition: "<X<",
    },
    dark_error: {
      left_value: "",
      right_value: 2,
      condition: ">=",
    },
  }, 
  inter_frequency_x1_ho_sr: {
    dark_success: {
      left_value: "",
      right_value: 99,
      condition: ">=",
    },
    dark_alert: {
      left_value: 99,
      right_value: 98,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 98,
      condition: "<=",
    },
  },
  sg_nb_addition_sr: {
    dark_success: {
      left_value: "",
      right_value: 99,
      condition: ">=",
    },
    dark_alert: {
      left_value: 99,
      right_value: 98,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 98,
      condition: "<=",
    },
  },
  lte_cell_availability: {
    dark_success: {
      left_value: "",
      right_value: 99.5,
      condition: ">=",
    },
    dark_alert: {
      left_value: 99.5,
      right_value: 99,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 99,
      condition: "<=",
    },
  },
  hand_in_success_rate: {
    dark_success: {
      left_value: "",
      right_value: 98,
      condition: ">=",
    },
    dark_alert: {
      left_value: 98,
      right_value: 95,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 95,
      condition: "<=",
    },
  },
  sgnb_addition_sr: {
    dark_success: {
      left_value: "",
      right_value: 99,
      condition: ">=",
    },
    dark_alert: {
      left_value: 99,
      right_value: 98,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 98,
      condition: "<=",
    },
  },
  endc_ue_session_drop_rate: {
    dark_success: {
      left_value: "",
      right_value: 0.5,
      condition: "<=",
    },
    dark_alert: {
      left_value: 0.5,
      right_value: 1,
      condition: "<X<",
    },
    dark_error: {
      left_value: "",
      right_value: 1,
      condition: ">=",
    },
  },
  intra_cu_handover_success_rate: {
    dark_success: {
      left_value: "",
      right_value: 99,
      condition: ">=",
    },
    dark_alert: {
      left_value: 99,
      right_value: 98,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 98,
      condition: "<=",
    },
  },
  nr_cell_availability: {
    dark_success: {
      left_value: "",
      right_value: 99.5,
      condition: ">=",
    },
    dark_alert: {
      left_value: 99.5,
      right_value: 99,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 99,
      condition: "<=",
    },
  },
};

export const ExternalPerformanceIconState: StateData = {
  dataAccessibilityPercent: {
    dark_success: {
      left_value: "",
      right_value: 99,
      condition: ">=",
    },
    dark_alert: {
      left_value: 99,
      right_value: 98,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 98,
      condition: "<=",
    },
  },
  volteAccessibilityPercent: {
    dark_success: {
      left_value: "",
      right_value: 99,
      condition: ">=",
    },
    dark_alert: {
      left_value: 99,
      right_value: 98,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 98,
      condition: "<=",
    },
  },
  dataRetainabilityPercent: {
    dark_success: {
      left_value: "",
      right_value: 99.5,
      condition: ">=",
    },
    dark_alert: {
      left_value: 99.5,
      right_value: 99,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 99,
      condition: "<",
    },
  },
  volteRetainabilityPercent: {
    dark_success: {
      left_value: "",
      right_value: 98.5,
      condition: ">=",
    },
    dark_alert: {
      left_value: 98.5,
      right_value: 97.5,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 97.5,
      condition: "<=",
    },
  },
  apMacroIntraHandoutPercent: {
    dark_success: {
      left_value: "",
      right_value: 98,
      condition: ">=",
    },
    dark_alert: {
      left_value: 98,
      right_value: 95,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 95,
      condition: "<=",
    },
  },
  apMacroInterFreqHandoutPercent: {
    dark_success: {
      left_value: "",
      right_value: 98,
      condition: ">=",
    },
    dark_alert: {
      left_value: 98,
      right_value: 95,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 95,
      condition: "<=",
    },
  },
  // intraEranInterFreqPercent: {
  //   dark_success: {
  //     left_value: "",
  //     right_value: 98,
  //     condition: ">=",
  //   },
  //   dark_alert: {
  //     left_value: 98,
  //     right_value: 95,
  //     condition: ">X>",
  //   },
  //   dark_error: {
  //     left_value: "",
  //     right_value: 95,
  //     condition: "<=",
  //   },
  // },
  // intraEranIntraFreqPercent: {
  //   dark_success: {
  //     left_value: "",
  //     right_value: 98,
  //     condition: ">=",
  //   },
  //   dark_alert: {
  //     left_value: 98,
  //     right_value: 95,
  //     condition: ">X>",
  //   },
  //   dark_error: {
  //     left_value: "",
  //     right_value: 95,
  //     condition: "<=",
  //   },
  // },
  x1HoIntraFreqPercent: {
    dark_success: {
      left_value: "",
      right_value: 98,
      condition: ">=",
    },
    dark_alert: {
      left_value: 98,
      right_value: 95,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 95,
      condition: "<=",
    },
  },
  x1HoInterFreqPercent: {
    dark_success: {
      left_value: "",
      right_value: 98,
      condition: ">=",
    },
    dark_alert: {
      left_value: 98,
      right_value: 95,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 95,
      condition: "<=",
    },
  },
  //NR ICONS
   endcDataAccessibilityPercent: {
    dark_success: {
      left_value: "",
      right_value: 99,
      condition: ">=",
    },
    dark_alert: {
      left_value: 99,
      right_value: 98,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 98,
      condition: "<=",
    },
  },
  endcDataRetainabilityPercent: {
    dark_success: {
      left_value: "",
      right_value: 99.5,
      condition: ">=",
    },
    dark_alert: {
      left_value: 99.5,
      right_value: 99,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 99,
      condition: "<",
    },
  },
  endcUeRetainabilityPercent: {
    dark_success: {
      left_value: "",
      right_value: 98.5,
      condition: ">=",
    },
    dark_alert: {
      left_value: 98.5,
      right_value: 97.5,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 97.5,
      condition: "<=",
    },
  },
  endcSgNBAdditionSuccessRate: {
    dark_success: {
      left_value: "",
      right_value: 98,
      condition: ">=",
    },
    dark_alert: {
      left_value: 98,
      right_value: 95,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 95,
      condition: "<=",
    },
  },
  endcIntraCUIntraFreqHandoverSuccessRate: {
    dark_success: {
      left_value: "",
      right_value: 98,
      condition: ">=",
    },
    dark_alert: {
      left_value: 98,
      right_value: 95,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 95,
      condition: "<=",
    },
  },
  endcIntraCUInterFreqHandoverSuccessRate: {
    dark_success: {
      left_value: "",
      right_value: 98,
      condition: ">=",
    },
    dark_alert: {
      left_value: 98,
      right_value: 95,
      condition: ">X>",
    },
    dark_error: {
      left_value: "",
      right_value: 95,
      condition: "<=",
    },
  },
}

export const SiteOptions = [
  // {
  //   name: "UNSUPPORTED",
  //   value: "UNSUPPORTED",
  // },
  {
    name: "UMTSONLY",
    value: "UMTSONLY",
  },
  {
    name: "LTEONLY",
    value: "LTEONLY",
  },
  {
    name: "UMTSAndLTE",
    value: "UMTSAndLTE",
  },
  {
    name: "NR",
    value: "NR",
  },
  {
    name: "DAS",
    value: "DAS"
  }
];

export const SnmpVersions = [ {name: "V2C", value:"1"}, {name: "V3", value:"3"}];
export const DasModelNames = [
  { name: "MA6000-G2", value: "MA6000-G2" },
  { name: "MA6200-G2", value: "MA6200-G2" },
  { name: "MA6200-G1", value: "MA6200-G1" },
  { name: "MA3000", value: "MA3000" }
];